import React, { useEffect } from 'react';
import {
    Grid,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
} from '@mui/material';
import clsx from 'clsx';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import {  Icons } from 'components';


const TypeAccountRadio = (props) => {
    const { isGroup, setIsGroup, classes } = props;

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} lg={6}>
                <RadioGroup
                    style={{ marginTop: 8 }}
                    row
                    xs={12}
                    required
                    onChange={(e) => {
                        setIsGroup(e?.target?.value === 'bulk' ? true : false);
                    }}
                    value={isGroup ? 'bulk' : 'single'}
                    defaultValue="single"
                >
                    <Grid container xs={12} justifyContent="space-between" spacing={1} style={{ position: 'relative' }}>
                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                value="single"
                                className={clsx(classes.radioItem, {
                                    active: !isGroup,
                                })}
                                control={<Radio className={classes.radioCircle} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                                label={
                                    <>
                                        <span className={classes.radioIcon}>
                                            <Icons icon='user' color='#2b3990' size='20' />
                                        </span>
                                        <Typography className={classes.radioText}>تفویض وجه تکی</Typography>
                                    </>
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControlLabel
                                value="bulk"
                                className={clsx(classes.radioItem, {
                                    active: isGroup,
                                })}

                                control={<Radio className={classes.radioCircle} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                                label={
                                    <>
                                        <span className={classes.radioIcon}>
                                            <Icons icon='users2' color='#2b3990' size='23' />
                                        </span>
                                        <Typography className={classes.radioText}>تفویض وجه گروهی</Typography>
                                    </>
                                }
                            />
                        </Grid>
                    </Grid>
                </RadioGroup>
            </Grid>
        </Grid>
    );
}


export default TypeAccountRadio;